import { render, staticRenderFns } from "./ContentWidthToggler.vue?vue&type=template&id=0b57ccac&"
import script from "./ContentWidthToggler.vue?vue&type=script&lang=js&"
export * from "./ContentWidthToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports